import '../css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from '../common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeLogId, checkLogin } from '../../store';
import { SyncLoader } from "react-spinners";
import Message from '../common/message';
import { changeNum, formatDateTime } from '../common/function';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function LogRandombox() {
    let dark = useSelector((state) => { return state.Darkmode.value });
    let log_id = useSelector((state) => { return state.log_id.value });

    const [search, setSearch] = useState(String(log_id).length > 0 ? String(log_id) : "")
    const [select, setSelect] = useState(false)
    const [selectValue, setSelectValue] = useState("ID")
    const [page, setPage] = useState(1)
    const [totalpage, setTotalPage] = useState(1)
    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    const [data, setData] = useState([])
    const [dateBtn, setDateBtn] = useState(0)
    const [selectedDate, setSelectedDate] = useState(() => {
        // 어제(D-1) 날짜
        const d = new Date();
        d.setDate(d.getDate() - 1);
        return d;
    });
    const [selectedDate1, setSelectedDate1] = useState(new Date());

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    const onChangeSearch = (e) => {
        setSearch(e.target.value)
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setReload(e => !e)
        }
    };

    const onSubmitSearch = () => {
        setReload(e => !e)
    }

    useEffect(() => {
        setTimeout(() => {
            dispatch(changeLogId(""))
        }, 100)
    }, [])


    useEffect(() => {
        UpgradeData();
    }, [page]);

    useEffect(() => {
        setPage(1);
        UpgradeData();
    }, [reload, selectedDate, selectedDate1]);

    const UpgradeData = async () => {
        setSpinner(true);
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/randombox/log', {
                params: {
                    page: page,
                    pageSize: 20,
                    startDate: formatDateTime(selectedDate),
                    endDate: formatDateTime(selectedDate1),
                    userId: search
                }
            });
            let tmp = response.data;
            if (tmp?.code === 1000) {
                console.log(tmp)
                setData(tmp?.data?.log ?? [])
                setTotalPage(tmp?.data?.pagination?.totalRecords ?? 0)
            }
        } catch (error) {
            console.log(error);
        }
        setSpinner(false);
    };

    // ------------------ 엑셀 다운로드 ------------------
    const excelBtn = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/randombox/log/excel', {
                params: {
                    startDate: formatDateTime(selectedDate),
                    endDate: formatDateTime(selectedDate1),
                    userId: search
                }
            });
            let tmp = response.data;
            if (tmp?.code === 1000) {
                excelData(tmp?.data?.log ?? [])
            }
        } catch (error) {
            console.log(error);
        }
    };

    const excelData = (exData) => {
        let arr = [];

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]

                arr.push({
                    "no": t.id,
                    "유저아이디": t.userId,
                    "박스ID": t.boxId,
                    "지급코인": t.amount,
                    "지급시간": t.date,
                })
            }
        }
        Excel(arr)
    };

    return (
        <div className='main'>
            <Message message={message} />
            <div className={`main-box ${darkname}`}>
                <div className='member-1'>
                    <div className={`member-2-search ${darkname}`}>
                        <div className={`member-1-select ${darkname}`} onClick={() => setSelect(e => !e)}>
                            <div className={`member-1-select-1 ${darkname}`}>{selectValue}</div>
                            {
                                select
                                    ?
                                    <FontAwesomeIcon icon={faSortUp} />
                                    :
                                    <FontAwesomeIcon icon={faSortDown} />
                            }
                            {
                                select
                                    ? <>
                                        <div className='modal' onClick={() => setSelect(true)}></div>
                                        <div className={`member-1-select-box ${darkname}`}>
                                            <div onClick={() => { setSelectValue("ID"); setSelect(true) }}>ID</div>
                                        </div>
                                    </>
                                    :
                                    ""
                            }
                        </div>
                        <FontAwesomeIcon icon={faWindowMinimize} className='line' />
                        <div className={`member-2-search-1 ${darkname}`}>
                            <input value={search} onChange={onChangeSearch} placeholder='Search' onKeyDown={handleKeyPress} />
                            <FontAwesomeIcon icon={faMagnifyingGlass} className='member-1-search-ico-3' />
                            {
                                search.length > 0
                                    ?
                                    <FontAwesomeIcon icon={faCircleXmark} className='member-1-search-ico-2' onClick={() => setSearch("")} />
                                    :
                                    ""
                            }
                        </div>
                    </div>
                    <div className={`search-btn ${darkname}`} onClick={() => onSubmitSearch()}>Search</div>
                    <div className={`modal-3-1-left ${darkname}`} style={{ marginLeft: "10px" }}>
                        <div
                            className={dateBtn === 1 ? "modal-3-1-left-1 on" : "modal-3-1-left-1"}
                            onClick={() => {
                                setDateBtn(1);

                                // 오늘 00시
                                const todayStart = new Date();
                                todayStart.setHours(0, 0, 0, 0);

                                // 지금 시각
                                const now = new Date();

                                setSelectedDate(todayStart);
                                setSelectedDate1(now);
                            }}
                        >
                            Today
                        </div>
                        <div
                            className={dateBtn === 5 ? "modal-3-1-left-1 on flex" : "modal-3-1-left-1 flex"}
                            onClick={() => setDateBtn(5)}
                            style={{ gap: "5px" /* 추가: 좌우 간격 */ }}
                        >
                            {/* 시작일 + 시간 */}
                            <DatePicker
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                // 날짜+시간 형식
                                dateFormat="yyyy-MM-dd HH:mm"
                                // 시간 선택 활성화
                                showTimeSelect
                                // 시:분 표기 형식 (24시간 등)
                                timeFormat="HH:mm"
                                // 시간 간격
                                timeIntervals={30}
                                // DatePicker 너비를 넉넉히 설정
                                className="datepicker-input"
                                placeholderText="시작일/시간 선택"
                                shouldCloseOnSelect
                                minDate={new Date("2000-01-01")}
                                maxDate={selectedDate1}
                            />
                            <div>~</div>
                            {/* 종료일 + 시간 */}
                            <DatePicker
                                selected={selectedDate1}
                                onChange={(date) => setSelectedDate1(date)}
                                dateFormat="yyyy-MM-dd HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={30}
                                className="datepicker-input"
                                placeholderText="종료일/시간 선택"
                                shouldCloseOnSelect
                                minDate={selectedDate}
                                maxDate={new Date()}
                            />
                        </div>
                    </div>
                </div>
                <div className='excel' style={{ marginTop: "10px" }} >
                    <div className={`excel-btn ${darkname}`} onClick={() => excelBtn()}>Excel download</div>
                </div>
                <div className={`member-2 ${darkname}`} style={{ width: "100%" }}>
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "10%", minWidth: "100px" }}>no.</div>
                        <div style={{ width: "10%", minWidth: "120px" }}>유저 아이디</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>박스 ID</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>지급 코인</div>
                        <div style={{ width: "10%", minWidth: "150px" }}>지급 시간</div>
                        <div>비고</div>
                    </div>
                    <div className='table-body' style={{ minHeight: "600px" }}>
                        {
                            spinner
                                ?
                                <div className='spinner-modal'>
                                    <SyncLoader color="#003577" />
                                </div>
                                :
                                data.length === 0
                                    ?
                                    <div className='data-nofound'>
                                        <img src='/img/img_nofound.png'></img>
                                        <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                        <p>NO RECORDS FOUND</p>
                                    </div>
                                    :
                                    <>
                                        {
                                            data.map(function (a, i) {
                                                return (
                                                    <MemberItem key={i} item={a} darkname={darkname} dark={dark} />
                                                )
                                            })
                                        }
                                        <NewPage initialData={totalpage} page={page} setPage={setPage} maxFirstPage={20} />
                                    </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, darkname, dark }) {
    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.id}</div>
                <div className='td' style={{ width: "10%", minWidth: "120px" }}>{item.userId}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.boxId}</div>
                <div className='right td' style={{ width: "10%", minWidth: "100px" }}>{changeNum(item.amount)}</div>
                <div className='td' style={{ width: "10%", minWidth: "150px" }}>{item.date}</div>
                <div className='td'></div>
            </div>
        </>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = '랜덤박스 로그';

    const headerRow = ["no", "유저아이디", "박스ID", "지급코인", "지급시간"];
    const bodyRows = excelData.map((data) => [data.no, data.유저아이디, data.박스ID, Number(data.지급코인), data.지급시간]);

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // 컬럼 너비
    ws['!cols'] = Array(headerRow.length).fill({ wpx: 120 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default LogRandombox;